import { Page, Tabs } from '@dixa/lib-shared-habla';
import { Outlet, useLocation } from 'react-router-dom';

import { useFeatureFlag } from 'utils/featureFlagging/useFeatureFlag';
import { useAppNavigate } from 'utils/url/useAppNavigate';

type SettingsChatbotsTabs = 'mim' | 'third-party';

const tabs = [
  { label: 'Mim chatbots', id: 'mim' },
  { label: 'Third party chatbots', id: 'third-party' },
];

export const SettingsChatbotsView = (): JSX.Element => {
  const flags = useFeatureFlag(['ada-chat-channel', 'mim-chatbot']);
  const navigate = useAppNavigate();
  const location = useLocation();

  const handleTabChange = (tab: string) => {
    navigate({ path: `/settings/chatbots/${tab as SettingsChatbotsTabs}` });
  };

  const selectedTab = location.pathname?.split('/').pop() ?? '';

  return (
    <Page>
      <Page.Head title="Chatbots" />

      {flags.adaChatChannel && flags.mimChatbot && (
        <Page.Tabs>
          <Tabs
            tabs={tabs}
            selectedId={selectedTab}
            onChange={handleTabChange}
          />
        </Page.Tabs>
      )}

      <Page.Body>
        <Outlet />
      </Page.Body>
    </Page>
  );
};
